<template>
	<section class="section ht-profile-user-transfer">
		<div class="columns is-centered">
			<div class="column is-7-widescreen is-6-fullhd">
				<div v-if="$route.params.type == 'success'" class="container">
					<h2 class="title">{{ $t('Thank you for your purchase.') }}</h2>
					<p>{{ $t('Transaction successful') }}
						<br>
						<span>
							{{getType(type)}} {{ $t('transaction ID') }}: {{$route.params.order_id}}
						</span>
					</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('Close') }}</b-button>
				</div>
				<div v-if="$route.params.type == 'fail'" class="container">
					<h2 class="title">{{ $t('Dear Customer') }}</h2>
					<p>
						{{ $t('Transaction failed') }}
						<br>
						{{ $t('SimplePay transaction ID') }}: {{$route.params.order_id}}
						<br>
						{{ $t('Please check the validity of data provided during the transaction. If all data are correct, please contact your bank which issued the card to request the reason for the refusal.') }}
						<br>
					</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('Close') }}</b-button>
				</div>	
				<div v-if="$route.params.type == 'cancel'" class="container">
					<h2 class="title">{{ $t('Dear Customer') }}</h2>
					<p>
						{{ $t('Transaction aborted') }}
						<br>
						{{ $t('Please contact us at') }}
						<a href="mailto:info@htaukcio.com">info@htaukcio.com</a>!
					</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('Close') }}</b-button>
				</div>
				<div v-if="$route.params.type == 'timeout'" class="container">
					<h2 class="title">{{ $t('Dear Customer') }}</h2>
					<p>{{ $t('Transaction timed out and failed') }}</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('Close') }}</b-button>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			loading: true,
			type:  '',
		}
	},
	props: {},
	mounted() {
		console.log('ROUTER', this.$route.params.order_id)
		localStorage.setItem('lang', this.getCookie('lang'))
		this.getOrder();
		this.lang = this.getCookie('lang')
		console.log('cookie', this.getCookie('lang'))
	},
	methods: {
		getType(type){
			switch(type){
				case 'SIMPLEPAY':
					return 'SimplePay';
				case 'PAYPAL':
					return 'PayPal';
				default:
					return 'Tranzakció';
			}
		},
		getOrder(){
			var	_this = this;
			_this.$http.post("/order/get/"+this.$route.params.order_id).then((response) => {
				this.type = response.data.order.type
				_this.loading = false
			})
		},
		getCookie(cname) {
			var name = cname + '='
			var decodedCookie = decodeURIComponent(document.cookie)
			var ca = decodedCookie.split(';')
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i]
				while (c.charAt(0) == ' ') {
					c = c.substring(1)
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length)
				}
			}
			return ''
		},
		closeWindow() {
			window.close()
		},
	},
	watch: {},
}
</script>
<style lang="css">
.ht-profile-user-pay-type {
	height: 50vh;
	padding-top: 40px;
	text-align: center;
}
.pay-success {
	color: green;
}
.pay-failed {
	color: red;
}
</style>
